export default __webpack_public_path__ + "static/treatmentareas_lipsbefore-70f6c21d81d19e04f0373e1061939dd3.webp";